module.exports = __webpack_public_path__ + "static/media/pari-about.87fa9eeb.jpg";